'use strict';

var _ = require('lodash');
var HistoryDrawerGridTransformerFactory = function HistoryDrawerGridTransformerFactory(momentService, DataTransformer, FieldNameTranslationService) {
  var CLEARED = 'CLEARED';
  var percentageValueFields = ['boardingRate', 'cancellationRate', 'overbookingPercentageModel', 'groupMaterializationRate', 'regularAggregateShare', 'mappedAggregateShare'];
  var segmentLimitTypes = ['BOTH', 'LOCAL', 'CONNECTING'];
  function HistoryDrawerGridTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'adjustment-history';
    this.targetType = 'adjustment-history-drawer';
    this.priority = 1;
  }
  HistoryDrawerGridTransformer.prototype = Object.create(DataTransformer.prototype);
  HistoryDrawerGridTransformer.constructor = HistoryDrawerGridTransformer;
  HistoryDrawerGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  HistoryDrawerGridTransformer.prototype.isCacheable = function () {
    return false;
  };
  HistoryDrawerGridTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  function formatValue(field) {
    var value = transformPercentageValue(field.value, field.fieldName);
    if (field.fieldName !== 'segmentLimitType') {
      return field.valueType === 'O' ? value : value + (value === CLEARED ? '' : field.valueType);
    } else {
      return segmentLimitTypes[parseInt(value)];
    }
  }
  function isPercentageValueFields(fieldName) {
    return percentageValueFields.indexOf(fieldName) !== -1;
  }
  function formatNumber(value) {
    if (/[a-zA-Z]/.test(value) || _.isNaN(parseFloat(value))) {
      return value;
    }
    return parseFloat(parseFloat(value).toFixed(2));
  }
  function transformPercentageValue(value, fieldName) {
    if (value === CLEARED) {
      return CLEARED;
    }
    return isPercentageValueFields(fieldName) ? formatNumber(value * 100) : formatNumber(value);
  }
  HistoryDrawerGridTransformer.prototype.transform = function (data) {
    function mapHistoryItem(item) {
      var momentDate = momentService.of(item.eventTimeStamp, momentService.FIELD.ADJUSTMENTS_HISTORY_DATE_TIME);
      var valueWithSuffix = formatValue(item);
      return {
        date: momentDate,
        appliedBy: item.appliedBy,
        appliedByRuleId: item.appliedByRuleId,
        ruleCreatedBy: item.ruleCreatedBy,
        fieldName: FieldNameTranslationService.nameToLabel(item.fieldName),
        valueWithSuffix: valueWithSuffix
      };
    }
    return _.map(data.domain.results, mapHistoryItem);
  };
  return HistoryDrawerGridTransformer;
};
HistoryDrawerGridTransformerFactory.$inject = ['MomentService', 'DataTransformerFactory', 'FieldNameTranslationService'];
module.exports = HistoryDrawerGridTransformerFactory;